import { render, staticRenderFns } from "./UploadFileCom.vue?vue&type=template&id=1cee20ce&"
import script from "./UploadFileCom.vue?vue&type=script&lang=ts&"
export * from "./UploadFileCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports